import { createContext, useContext, useEffect, useState } from "react";
import { api, MANAGERS, APPROVERS } from "./api";

const AuthCtx = createContext(null);
const LEVELS = { none: 0, view: 1, check: 2, manage: 3 };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("eps_token", data.token);
    setUser(data.user);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("eps_token");
    setUser(false);
  };
  const role = user?.role;
  const value = {
    user, login, logout,
    isManager: MANAGERS.includes(role),
    isApprover: APPROVERS.includes(role),
    canWrite: !!user && role !== "auditor",
    can: (m, l) => !!user && LEVELS[user.perms?.[m] || "none"] >= LEVELS[l],
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
